import Logins from './Logins';

export default Logins;
